<template>
  <modal id="out-of-stock-modal">
    <div class="modal-body" slot="body">
      <form @submit.prevent="submit">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label>Kontakt telefon</label>
              <input
                type="text"
                class="form-control"
                v-model="profile.userData.phoneNumber"
                placeholder="Kontakt telefon"
                readonly
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div class="form-group">
              <label>Email</label>
              <input
                type="email"
                readonly
                class="form-control"
                v-model="profile.userData.email"
                placeholder="Email"
              />
            </div>
          </div>
          <div class="col-12">
            <label>{{ translations.comment }}</label>
            <textarea
              class="form-control"
              v-model="comment"
              :placeholder="translations.comment"
              required
            ></textarea>
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button type="submit" class="btn btn-primary">Pošalji upit</button>
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
import api from '@/services/api';
import { translations } from '@/mixins';
import Modal from '@/components/shared/modal/Modal.vue';

export default {
  name: 'OutOfStockModal',
  mixins: [translations],
  components: {
    Modal,
  },
  data() {
    return {
      comment: '',
    };
  },
  mounted() {
    $('#out-of-stock-modal').on('hidden.bs.modal', () => {
      this.comment = '';
      this.$store.dispatch('hideOutOfStockModal');
    });
  },
  computed: {
    isVisible() {
      return this.$store.getters.getOutOfStockModal.isVisible;
    },
    articleId() {
      return this.$store.getters.getOutOfStockModal.articleId;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
  },
  watch: {
    isVisible(visible) {
      this.$nextTick(() => {
        if (visible) {
          $('#out-of-stock-modal').modal('show');
        } else {
          $('#out-of-stock-modal').modal('hide');
        }
      });
    },
  },
  methods: {
    submit() {
      const payload = {
        articleId: this.articleId,
        comment: this.comment,
      };

      api
        .createOutOfStockRequest(payload)
        .then((response) => {
          this.$toast.info(response.data.info);
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        })
        .finally(() => this.$store.dispatch('hideOutOfStockModal'));
    },
  },
};
</script>

<style lang="scss" scoped></style>
